function CustomTab(props) {
  const tabList = [
    { key: "school", text: "School" },
    { key: "teacher", text: "Teacher" },
    { key: "industry", text: "Industry" },
    { key: "visitor", text: "Visitor" },
  ];
  return (
    <div className="custom-tab">
      {tabList.map((tabs) => (
        <div
          className="tab"
          style={{
            border: props.selected === tabs.key ? "solid var(--text-color) 1px" : "0",
            fontWeight: props.selected === tabs.key ? "bold" : "normal",
          }}
          onClick={() => {
            props.onSelected(tabs.key);
          }}
        >
          {tabs.text}
        </div>
      ))}
    </div>
  );
}

export default CustomTab;
